<div class="section">
  <div class="row pagetitle-row">
    <div class="pagetitle">
      <div class="nav-icons education">
        <i class="fa fa-chevron-up fa-2x" aria-hidden="true"></i>
      </div>
      <h1 class="education">Component 2</h1>
    </div>
  </div>

  <form
    class="full-width"
    novalidate="novalidate"
    (ngSubmit)="save()"
    [formGroup]="educationForm"
  >
    <app-education-child
      [educationChild]="medicalSchool"
      [accountType]="AccountType.MEDICALSCHOOL"
      [TITLE]="'Medical School'"
    ></app-education-child>

    <app-education-child
      [educationChild]="residency"
      [accountType]="AccountType.RESIDENCY"
      [TITLE]="'Residency'"
    ></app-education-child>

    <app-education-child
      [educationChild]="fellowship"
      [accountType]="AccountType.FELLOWSHIP"
      [TITLE]="'Fellowship'"
      *ngIf="memberType != MemberType.Student"
    ></app-education-child>

    <app-education-child
      [educationChild]="boardCertification"
      [accountType]="AccountType.BOARDCERTIFICATION"
      [TITLE]="'Credentials'"
      *ngIf="memberType == MemberType.Physician"
    ></app-education-child>

    <div class="margin-top-40" *ngIf="memberType == MemberType.Physician">
      <p>
        All applicants for regular membership shall, hold a current, active,
        full, valid, unrestricted, and unqualified license to practice medicine
        in the state, province, territory, or foreign country in which they
        practice, or be serving in a governmental medical assignment. All
        regular members must either continue to maintain a valid license to
        practice medicine or have voluntarily relinquished the license upon
        leaving medical practice. A license to practice medicine shall not be
        considered voluntarily relinquished if it was surrendered, made
        inactive, or allowed to expire under threat of probation or suspension
        or other condition or limitation upon said license to practice medicine
        by a licensing body in any jurisdiction.
      </p>

      <div
        class="validationwrap"
        [class.validation-error]="
          attest.invalid && (attest.dirty || attest.touched || formSubmitted)
        "
      >
        <mat-checkbox color="primary" formControlName="attest"
          ><strong
            >I attest the above information is correct</strong
          ></mat-checkbox
        >
        <span class="validationhead">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          Required</span
        >
      </div>
    </div>

    <div class="row actions">
      <div class="col-md-12">
        <button mat-raised-button="mat-raised-button" class="btnSave">
          Save and Continue
        </button>
      </div>
    </div>
  </form>

  <pre *ngIf="isDevEnv">
    <code>
      {{educationDetails | json}}
      {{educationForm.value | json}}
    </code>
  </pre>
</div>
